module.exports = __webpack_public_path__ + "img/name-aula.11702024.svg";